import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../constants/layout/store/filterSlice";
import { GetServiceCaller } from "../../../services/serviceCaller";
import { API_URL } from "../../../constants";
// Ensure you have react-icons installed for these imports:
import { FaSpinner, FaChevronLeft, FaChevronRight } from "react-icons/fa";
import achieverAward from "../../../assets/Achiever_Award.png";

const AchieversLeaderBoard = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(updateNavbarHeading("Achievers Leaderboard"));
  }, []);

  const [twelveMonthData, setTwelveMonthData] = useState([]);
  console.log("twelveMonthData", twelveMonthData);

  const [threeMonthData, setThreeMonthData] = useState([]);
  console.log("ThreeMonth::", threeMonthData);
  const [pageLoading, setPageLoading] = useState(true);
  useEffect(() => {
    fetchAchieversLeaderboardData();
  }, []);

  const fetchAchieversLeaderboardData = async () => {
    try {
      const response = await GetServiceCaller(
        `${API_URL}nest/dashboard/employee-achivers`
      );
      if (response.status === 200) {
        // Twelve Month Data
        const leaderData = response?.data?.leaderboardyear;
        setTwelveMonthData(leaderData);
        // Three Month Data
        const leaderThreeData = response?.data?.threemonthleaderboard;
        setThreeMonthData(leaderThreeData);
        setPageLoading(false);
      } else {
        console.error(
          "Failed to fetch LeaderBoard Data. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      console.error("Error fetching Project:", error);
    }
  };

  /**
   * Award Carousel Component - Implements smooth sliding and navigation buttons
   */
  const AwardCarousel = ({ awards = [] }) => {
    const [currentIndex, setCurrentIndex] = useState(0);
    const [hoveredIndex, setHoveredIndex] = useState(null);

    const ITEMS_VISIBLE = 2;
    const totalItems = awards.length;
    const totalSlides = Math.ceil(totalItems / ITEMS_VISIBLE);

    // Width of a single award item (80px) + gap (20px) = 100px
    const ITEM_WIDTH_PX = 100;

    if (!awards || awards.length === 0) return null;

    const handlePrev = () => {
      // Go to the previous slide, looping to the end if at the start
      setCurrentIndex((prev) => (prev === 0 ? totalSlides - 1 : prev - 1));
    };

    const handleNext = () => {
      // Go to the next slide, looping to the start if at the end
      setCurrentIndex((prev) => (prev + 1) % totalSlides);
    };

    // Calculate the translation value based on the current slide index
    const translateValue = currentIndex * ITEMS_VISIBLE * ITEM_WIDTH_PX;

    // Calculate the total width needed to hold ALL items for the scrolling container
    const innerContainerWidth = totalItems * ITEM_WIDTH_PX;

    return (
      <div
        style={{
          textAlign: "center",
          position: "relative",
          width: "200px", // Fixed width for the visible area (2 items * 100px)
          margin: "0 auto",
          padding: "10px 0",
        }}
      >
        {/* Carousel Wrapper - Creates the viewport, hides overflow */}
        <div
          style={{
            overflow: "hidden", // Hides awards that are off-screen
            width: "100%",
          }}
        >
          {/* Carousel Inner Content - Contains ALL awards, moves via transform */}
          <div
            style={{
              display: "flex",
              width: `${innerContainerWidth}px`, // Wide enough for ALL items
              transform: `translateX(-${translateValue}px)`, // Sliding motion
              transition: "transform 0.5s ease-in-out", // Smooth transition
              justifyContent: "flex-start",
              alignItems: "flex-start",
              gap: "20px",
              padding: "5px 10px",
            }}
          >
            {awards.map((award, index) => (
              <div
                key={index}
                style={{
                  width: "80px", // Fixed item width
                  flexShrink: 0, // Prevent items from shrinking
                  transition: "all 0.3s ease",
                  position: "relative",
                  overflow: "visible",
                }}
                onMouseEnter={() => setHoveredIndex(index)}
                onMouseLeave={() => setHoveredIndex(null)}
              >
                {/* Award Image */}
                <img
                  src={award.FileBage}
                  alt={award.Name}
                  style={{
                    width: "40px",
                    height: "40px",
                    objectFit: "contain",
                    borderRadius: "50%",
                    display: "block",
                    margin: "0 auto",
                    border: "2px solid #ddd",
                  }}
                />

                {/* Award Name */}
                <div
                  style={{
                    fontSize: "12px",
                    color: "#333",
                    marginTop: "5px",
                    height: "40px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    textAlign: "center",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    wordWrap: "break-word",
                    lineHeight: "1.2",
                  }}
                  // title={award.AwardDetails || award.Name}
                >
                  {award.Name}
                </div>

                {/* Tooltip (Fixed Position and Content) */}
                {hoveredIndex === index && (
                  <div
                    style={{
                      position: "absolute",
                      top: "10%",
                      left: "50%",
                      transform: "translateX(-50%)",
                      // marginBottom: "10px",
                      backgroundColor: "#222",
                      color: "white",
                      padding: "6px 10px",
                      borderRadius: "4px",
                      fontSize: "11px",
                      maxWidth: "250px",
                      whiteSpace: "normal",
                      wordWrap: "break-word",
                      lineHeight: "1",
                      // textAlign: "center",
                      zIndex: 100,
                      boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
                    }}
                  >
                    <span style={{ fontWeight: "bold" }}>{award.Name}</span>
                    {/* <br />
                    {award.AwardDetails || "Details unavailable."}
                    <div
                      style={{
                        position: "absolute",
                        top: "110%",
                        left: "50%",
                        transform: "translateX(-50%)",
                        width: "0",
                        height: "0",
                        borderLeft: "6px solid transparent",
                        borderRight: "6px solid transparent",
                        borderTop: "6px solid #222",
                        cursor: "pointer",
                      }}
                    /> */}
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
        {/* --- Navigation Buttons with Icons --- */}
        {totalSlides > 1 && ( // Buttons appear only if there is more than one slide (i.e., 3+ awards)
          <>
            {/* Left Button */}
            <button
              onClick={handlePrev}
              style={{
                position: "absolute",
                top: "35px",
                left: "-7px",
                background: "none",
                transform: "translateY(-50%)",
                border: "none",
                cursor: "pointer",
                fontSize: "10px",
                color: "#555",
                padding: "5px",
              }}
              aria-label="Previous Award"
            >
              <FaChevronLeft />
            </button>

            {/* Right Button */}
            <button
              onClick={handleNext}
              style={{
                position: "absolute",
                top: "35px",
                right: "-7px",
                transform: "translateY(-50%)",
                background: "none",
                border: "none",
                cursor: "pointer",
                fontSize: "10px",
                color: "#555",
                padding: "5px",
              }}
              aria-label="Next Award"
            >
              <FaChevronRight />
            </button>
          </>
        )}
      </div>
    );
  };

  // ... (rest of AchieversLeaderBoard component unchanged)
  if (pageLoading) {
    return (
      <>
        <p className="position-absolute top-50 start-50 translate-middle text-center">
          <FaSpinner className="spinner" />
        </p>
      </>
    );
  } else {
    return (
      <div
        className="container-fluid"
        id="skill_section"
        style={{ overflowY: "hidden", height: "100vh" }}
      >
        <div className="container-fluid" id="rank-Emp">
          <ul
            className="nav nav-tabs overflow d-flex justify-content-end gap-1 p-0"
            id="myTab"
            role="tablist"
          >
            <li className="nav-item" role="presentation">
              <button
                className="nav-link active px-4 py-1 text-center"
                style={{ color: "#2F2E4B" }}
                id="twelve-tab"
                data-bs-toggle="tab"
                data-bs-target="#twelve"
                type="button"
                role="tab"
                aria-controls="twelve"
                aria-selected="true"
              >
                Last 12 Months
              </button>
            </li>
            <li className="nav-item" role="presentation">
              <button
                className="nav-link px-4 py-1 text-center"
                style={{ color: "#2F2E4B" }}
                id="three-tab"
                data-bs-toggle="tab"
                data-bs-target="#three"
                type="button"
                role="tab"
                aria-controls="three"
                aria-selected="false"
              >
                Last 3 Months
              </button>
            </li>
          </ul>

          <div className="tab-content" id="myTabContent">
            {/* Twelve Month Section (uses map, but no carousel is shown here) */}
            <div
              className="tab-pane fade show active"
              id="twelve"
              role="tabpanel"
              aria-labelledby="twelve-tab"
            >
              <div className="leader-info">
                <div className="Achiever-LeaderBoard mt-1">
                  <div className="d-flex text-center Achiever-LeaderBoard-content">
                    {twelveMonthData.map((user, index) => (
                      <div
                        key={index}
                        className={`leader-profile-card rank-${user.rank}`}
                        style={{
                          order: user.rank === 1 ? 2 : user.rank === 2 ? 1 : 3,
                        }}
                      >
                        <div className="leader-profile-image-container">
                          <div className="leader-badgeimg">
                            <img src={user.TrophiePath || ""} alt="Trophy" />
                          </div>
                          <img
                            src={user.FilePath || ""}
                            alt="Profile"
                            className="leader-profile-image"
                          />
                        </div>

                        <div className="leader-profile-info">
                          <div className="leader-profile-name fw-bold">
                            {user.Name || ""}
                          </div>
                          <div className="leader-profile-rank">
                            Score: {user.score || ""}
                          </div>

                          {/* dotted HR line */}
                          <hr className="achiever-dotted" />

                          {/* <div>
                            <img
                              className="achieverAward"
                              src={achieverAward}
                              alt="Awardimg"
                            />
                          </div>

                          <div className="leader-profile-name fw-bold">
                            Customer Hero Award
                          </div> */}
                          <div
                            style={{
                              position: "relative",
                              overflow: "hidden",
                              height: "120px",
                            }}
                          >
                            {user.awards && user.awards.length > 0 ? (
                              <AwardCarousel awards={user.awards} />
                            ) : (
                              <div
                                className="leader-profile-name fw-bold"
                                style={{ fontSize: "12px" }}
                              >
                                No Awards
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>

            {/* Three Month Section (where the AwardCarousel is used) */}
            <div
              className="tab-pane fade"
              id="three"
              role="tabpanel"
              aria-labelledby="three-tab"
            >
              <div className="leader-info">
                <div className="Achiever-LeaderBoard mt-1">
                  <div className="d-flex text-center Achiever-LeaderBoard-content">
                    {threeMonthData.map((user, index) => (
                      <div
                        key={index}
                        className={`leader-profile-card rank-${user.rank}`}
                        style={{
                          order: user.rank === 1 ? 2 : user.rank === 2 ? 1 : 3,
                        }}
                      >
                        <div className="leader-profile-image-container">
                          <div className="leader-badgeimg">
                            <img src={user.TrophiePath || ""} alt="Trophy" />
                          </div>
                          <img
                            src={user.FilePath || ""}
                            alt="Profile"
                            className="leader-profile-image"
                          />
                        </div>

                        <div className="leader-profile-info">
                          <div className="leader-profile-name fw-bold">
                            {user.Name || ""}
                          </div>
                          <div className="leader-profile-rank">
                            Score: {user.score || ""}
                          </div>

                          {/* dotted HR line */}
                          <hr className="achiever-dotted" />
                          <div
                            style={{
                              position: "relative",
                              overflow: "hidden",
                              height: "120px",
                            }}
                          >
                            {user.awards && user.awards.length > 0 ? (
                              <AwardCarousel awards={user.awards} />
                            ) : (
                              <div
                                className="leader-profile-name fw-bold"
                                style={{ fontSize: "12px" }}
                              >
                                No Awards
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
};

export default AchieversLeaderBoard;
